import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Space, Typography } from 'antd';
// import { MailFilled, PhoneFilled } from '@ant-design/icons';
// import { AddressIcon, MidIcon, BusinessnEntityIcon } from 'utils/icons';
import userCard from 'assets/images/user_card.webp';

function UserInfoCard({ name, email, phone, businessName, address, mid }) {
  return (
    <div
      style={{
        backgroundImage: `url(${userCard})`,
        backgroundSize: 'cover',
        boxShadow: '0px 2px 6px #0000001A',
        borderRadius: '13px',
        padding: '14px',
        paddingLeft: '6%',
        paddingRight: '6%',
        height: '100%',
        color: 'white'
      }}
    >
      <div
        direction="horizontal"
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography.Text
          style={{
            fontSize: '24px',
            letterSpacing: '0px',
            fontWeight: '500',
            color: 'white'
          }}
          ellipsis={{ tooltip: true }}
        >
          {name}
        </Typography.Text>
        {/* <Tag color="#0A9305" style={{ borderRadius: '50px' }}>
          Active
        </Tag> */}
      </div>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={24}>
              <Space>
                <Space>
                  {/* <MailFilled /> */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography.Text style={{ color: 'white', fontWeight: '500' }}>
                      Gmail:
                    </Typography.Text>
                    <Typography.Text underline style={{ color: 'white' }}>
                      {email}
                    </Typography.Text>
                  </div>
                </Space>
              </Space>
            </Col>
            <Col span={24}>
              <Space direction="horizontal" align="top" style={{ marginTop: '20px' }}>
                <Space>
                  {/* <MidIcon /> */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography.Text style={{ color: 'white', fontWeight: '500' }}>
                      MID:
                    </Typography.Text>
                    <Typography.Text style={{ color: 'white' }}>{mid}</Typography.Text>
                  </div>
                </Space>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={24}>
              <Space>
                {/* <PhoneFilled /> */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ color: 'white', fontWeight: '500' }}>
                    Phone No:
                  </Typography.Text>
                  <Typography.Text style={{ color: 'white' }}>{phone}</Typography.Text>
                </div>
              </Space>
            </Col>
            <Col span={24}>
              <Space style={{ marginTop: '20px' }}>
                {/* <BusinessnEntityIcon /> */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography.Text style={{ color: 'white', fontWeight: '500' }}>
                    Business Name :
                  </Typography.Text>
                  <Typography.Text style={{ color: 'white', fontSize: '14px' }}>
                    {businessName}
                  </Typography.Text>
                </div>
              </Space>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Space direction="horizontal" align="top" style={{ marginTop: '20px' }}>
            {/* <AddressIcon /> */}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography.Text style={{ color: 'white', fontWeight: '500' }}>
                Address :
              </Typography.Text>
              <Typography.Text style={{ color: 'white', fontSize: '14px' }}>
                {address}
              </Typography.Text>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
}

UserInfoCard.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  businessName: PropTypes.string,
  address: PropTypes.string,
  mid: PropTypes.number
};

UserInfoCard.defaultProps = {
  businessName: '',
  address: '',
  mid: null
};

export default UserInfoCard;
